import actions from "./actions";

const events = actions;

/**
 * Procedure de instalação do plugin
 *
 * @param Vue
 */

const install = function(Vue) {
  Vue.prototype.$popup = Vue.popup = new events();
};

export default { install };
